module.exports = __webpack_public_path__ + "static/assets/a8f3ce9fb80d558020a867afe7a840cd.gif";